import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AccountBilling } from '../../gdo-shared/Models/account-billing';

@Injectable({
  providedIn: 'root'
})
export class GdoPaymentService {
  companyChanged = new Subject<AccountBilling>();

  private companies: AccountBilling[] = [
    {
      date: '09/12/2020',
      type: 'Payment',
      desc: '*REFUND* Telematics Package',
      amount: '-$95.0',
      action: 'View',
    },
    {
      date: '09/12/2020',
      type: 'Invoice',
      desc: '*REFUND* Telematics Package',
      amount: '-$95.0',
      action: 'View',
    },
    {
      date: '09/12/2020',
      type: 'Payment',
      desc: '*REFUND* Telematics Package',
      amount: '-$95.0',
      action: 'View',
    },
    {
      date: '09/12/2020',
      type: 'Invoice',
      desc: '*REFUND* Telematics Package',
      amount: '-$95.0',
      action: 'View',
    },
  ];

  getCompanies() {
    return this.companies.slice();
  }
}
